import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import cx from 'classnames';
import StackNavigator from '../../../components/stateful/StackNavigator';
import styles from './MobileNav.scss';
import PlaceholderIcon from '../../../../modules/react/components/stateless/PlaceholderIcon';
import useCurrentPage from '../../../hooks/useCurrentPage';
import MobileNavbarButton from '../../../components/stateless/MobileNavbarButton/MobileNavbarButton';

const propTypes = {
  inverseBackground: PropTypes.bool,
  navigation: PropTypes.arrayOf(PropTypes.shape({
    page: PropTypes.shape({
      path: PropTypes.string,
      title: PropTypes.string.isRequired,
    }),
    text: PropTypes.string,
    link: PropTypes.shape({
      target: PropTypes.string,
      href: PropTypes.string,
    }),
    navigationItems: PropTypes.array,
  })),
};

const defaultProps = {
  inverseBackground: undefined,
  navigation: [],
};

const MobileNav = ({ navigation, primaryButton, secondaryButton, inverseBackground }) => {
  const ref = useRef(null);
  const [navExpanded, updateNavExpanded] = useState(false);
  const [title, updateTitle] = useState();
  const [back, updateBack] = useState(false);
  const [navWrapperHeight, setNavWrapperHeight] = useState(0);
  const { primaryColorBackgroundClass } = useCurrentPage();

  useEffect(() => {
    if (!ref) { return; }

    const wrapperInnerHeight = window.innerHeight;
    const boundingRect = ref.current.getBoundingClientRect();
    setNavWrapperHeight(wrapperInnerHeight - boundingRect.top);
  }, [ref]);

  // Look, this just triggers a listener... Don't question it too hard.
  const toggleBack = () => {
    updateBack(!back);
  };
  const toggleNav = () => {
    document.body.classList.toggle('hide-overflow', !navExpanded);
    updateNavExpanded(!navExpanded);
  };

  return (
    <>
      <div className={cx(
        styles.navHeader,
        {
          [primaryColorBackgroundClass]: inverseBackground,
          [styles.overlay]: !!title,
        },
      )}
      >
        {title
          ? (
            <div className={styles.titleDiv}>
              <button
                className={cx(
                  styles.navBackButton,
                  { [styles.inverseButton]: inverseBackground },
                )}
                type="button"
                onClick={toggleBack}
              >
                <PlaceholderIcon.LeftChevron />
              </button>
              <span
                className={cx(styles.title, { [styles.inverseBackground]: inverseBackground })}
              >
                {title || ''}
              </span>
            </div>
          ) : <div />}
          {/* <NavbarToggle
            aria-controls="responsive-navbar-nav"
            role="navigation"
            variant="dark"
            className={cx({
              navbarCollapsed: !navExpanded,
              [styles.inverseButton]: inverseBackground,
            })}
            onClick={toggleNav}
          /> */}
          {/* <Navbar expand={navExpanded} className={styles.navToggle}>
             <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={toggleNav} />
              <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
              {navExpanded && (
              <Button className={`close-btn ${styles.closeButton}`}
              variant="default" onClick={toggleNav}>
               &times;
              </Button>
              )}
              </Navbar.Collapse>
          </Navbar> */}
          {/* <Navbar expand="lg" closeButton={navExpanded} collapseOnSelect>
           <Navbar.Toggle onClick={toggleNav} />
          </Navbar> */}
          {/* <Button id="toggleButton" className={styles.mobileNavButton}
          onClick={toggleNav} variant="default">
            <div className={navExpanded ? styles.menuIconOpen :
            styles.menuIconClose} id="iconContainer">
              <div className={styles.bar} />
              <div className={styles.bar} />
              <div className={styles.bar} />
            </div>
          </Button> */}
          <MobileNavbarButton toggleNav={toggleNav} navExpanded={navExpanded} />
      </div>
      <div ref={ref} style={navExpanded ? { height: `${navWrapperHeight}px` } : { height: 0 }}>
        <StackNavigator
          visible={navExpanded}
          transition={'right'}
          items={navigation}
          back={back}
          updateTitle={updateTitle}
          primaryButton={primaryButton}
          secondaryButton={secondaryButton}
        />
      </div>
    </>
  );
};

MobileNav.propTypes = propTypes;
MobileNav.defaultProps = defaultProps;

MobileNav.fragments = (() => {
  const page = gql`
    fragment MobileNavNavigationItemPageFields on Page {
      path
      title
    }
  `;

  const navigationItemFields = gql`
    fragment MobileNavNavigationItemFields on NavigationItem {
      id
      text
      link {
        href
        target
      }
      page {
        id
        ...MobileNavNavigationItemPageFields
      }
    }

    ${page}
  `;

  return {
    navigationItem: gql`
      fragment MobileNavNavigationItems on NavigationItem {
        ...MobileNavNavigationItemFields
        navigationItems {
          ...MobileNavNavigationItemFields
          navigationItems {
            ...MobileNavNavigationItemFields
            navigationItems {
              ...MobileNavNavigationItemFields
            }
          }
        }
      }

      ${navigationItemFields}
    `,
    page,
  };
})();

export default MobileNav;
